export enum PressurePeriodTypes {
  DAILY = "DAILY",
  HOURLY = "HOURLY",
  OPERATIONAL = "OPERATIONAL",
}
